export default "__VITE_ASSET__c847003d__"